import React, { useState } from "react";
import SignaturePad from "components/common/SignaturePad";

const SignatureForm: React.FC = () => {
  const [signature, setSignature] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    //console.log("Form submitted with signature:", signature);
    // send `signature` (base64 PNG) to backend API or save
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <input type="text" name="name" placeholder="Your Name" className="border p-2 w-full" />

      <label className="block font-semibold">Signature:</label>
      <SignaturePad onChange={setSignature} />

      {signature && (
        <div className="mt-2">
          <p className="font-semibold">Preview:</p>
          <img src={signature} alt="Signature preview" className="border mt-1" />
        </div>
      )}

      <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded">
        Submit
      </button>
    </form>
  );
};

export default SignatureForm;